import * as TableConstants from 'notebook/tables/TableConstants';

import {Format} from '../formatted-text/FormattersConstants';

interface BaseWYCIWYPPart {
  formats: Format;
  indentation: number | undefined;
  listType: string | null | undefined;
  time?: number;
  alignment?: 'left' | 'right' | 'center' | null;
}

export interface TableWYCIWYPPart extends BaseWYCIWYPPart {
  text: TableConstants.Table;
  type: 'table';
}

export interface NonTableWYCIWYPPart extends BaseWYCIWYPPart {
  text: string;
  type?: string;
  code?: string;
  headerLevel?: number;
}

export type WYCIWYPPart = TableWYCIWYPPart | NonTableWYCIWYPPart;

export const MISSING = '\ufffd';

const WINGDINGS_TO_UNICODE = [
  // CHAR  // DEC
  MISSING, // 0
  MISSING, // 1
  MISSING, // 2
  MISSING, // 3
  MISSING, // 4
  MISSING, // 5
  MISSING, // 6
  MISSING, // 7
  MISSING, // 8
  MISSING, // 9
  MISSING, // 10
  MISSING, // 11
  MISSING, // 12
  MISSING, // 13
  MISSING, // 14
  MISSING, // 15
  MISSING, // 16
  MISSING, // 17
  MISSING, // 18
  MISSING, // 19
  MISSING, // 20
  MISSING, // 21
  MISSING, // 22
  MISSING, // 23
  MISSING, // 24
  MISSING, // 25
  MISSING, // 26
  MISSING, // 27
  MISSING, // 28
  MISSING, // 29
  MISSING, // 30
  MISSING, // 31
  '\u0020', // 32
  '\u270F', // 33
  '\u2702', // 34
  '\u2701', // 35
  '\u1F453', // 36
  '\u1F56D', // 37
  '\u1F56E', // 38
  '\u1F56F', // 39
  '\u1F57F', // 40
  '\u2706', // 41
  '\u1F582', // 42
  '\u1F583', // 43
  '\u1F4EA', // 44
  '\u1F4EB', // 45
  '\u1F4EC', // 46
  '\u1F4ED', // 47
  '\u1F4C1', // 48
  '\u1F4C2', // 49
  '\u1F4C4', // 50
  '\u1F5CF', // 51
  '\u1F5D0', // 52
  '\u1F5C4', // 53
  '\u231B', // 54
  '\u1F5AE', // 55
  '\u1F5B0', // 56
  '\u1F5B2', // 57
  '\u1F5B3', // 58
  '\u1F5B4', // 59
  '\u1F5AB', // 60
  '\u1F5AC', // 61
  '\u2707', // 62
  '\u270D', // 63
  MISSING, // 64
  '\u270C', // 65
  '\u1F44C', // 66
  '\u1F44D', // 67
  '\u1F44E', // 68
  '\u261C', // 69
  '\u261E', // 70
  '\u261D', // 71
  '\u261F', // 72
  '\u270B', // 73
  '\u263A', // 74
  '\u1F610', // 75
  '\u2639', // 76
  '\u1F4A3', // 77
  '\u2620', // 78
  '\u2690', // 79
  '\u1F3F1', // 80
  '\u2708', // 81
  '\u263C', // 82
  '\u1F4A7', // 83
  '\u2744', // 84
  '\u1F546', // 85
  '\u271E', // 86
  '\u1F548', // 87
  '\u2720', // 88
  '\u2721', // 89
  '\u262A', // 90
  '\u262F', // 91
  '\u0950', // 92
  '\u2638', // 93
  '\u2648', // 94
  '\u2649', // 95
  '\u264A', // 96
  '\u264B', // 97
  '\u264C', // 98
  '\u264D', // 99
  '\u264E', // 100
  '\u264F', // 101
  '\u2650', // 102
  '\u2651', // 103
  '\u2652', // 104
  '\u2653', // 105
  '\u0026', // 106
  '\u0026', // 107
  '\u25CF', // 108
  '\u274D', // 109
  '\u25A0', // 110
  '\u25A1', // 111
  MISSING, // 112
  '\u2751', // 113
  '\u2752', // 114
  '\u2B27', // 115
  '\u29EB', // 116
  '\u25C6', // 117
  '\u2756', // 118
  '\u2B25', // 119
  '\u2327', // 120
  '\u2353', // 121
  '\u2318', // 122
  '\u2740', // 123
  '\u273F', // 124
  '\u275D', // 125
  '\u275E', // 126
  '\u25AF', // 127
  '\u24EA', // 128
  '\u2460', // 129
  '\u2461', // 130
  '\u2462', // 131
  '\u2463', // 132
  '\u2464', // 133
  '\u2465', // 134
  '\u2466', // 135
  '\u2467', // 136
  '\u2468', // 137
  '\u2469', // 138
  '\u24FF', // 139
  '\u2776', // 140
  '\u2777', // 141
  '\u2778', // 142
  '\u2779', // 143
  '\u277A', // 144
  '\u277B', // 145
  '\u277C', // 146
  '\u277D', // 147
  '\u277E', // 148
  '\u277F', // 149
  MISSING, // 150
  MISSING, // 151
  MISSING, // 152
  MISSING, // 153
  MISSING, // 154
  MISSING, // 155
  MISSING, // 156
  MISSING, // 157
  '\u00B7', // 158
  '\u2022', // 159
  '\u25AA', // 160
  '\u25CB', // 161
  '\u2B55', // 162
  MISSING, // 163
  '\u25C9', // 164
  '\u25CE', // 165
  MISSING, // 166
  '\u25AA', // 167
  '\u25FB', // 168
  MISSING, // 169
  '\u2726', // 170
  '\u2605', // 171
  '\u2736', // 172
  '\u2734', // 173
  '\u2739', // 174
  '\u2735', // 175
  MISSING, // 176
  '\u2316', // 177
  '\u27E1', // 178
  '\u2311', // 179
  MISSING, // 180
  '\u272A', // 181
  '\u2730', // 182
  '\u1F550', // 183
  '\u1F551', // 184
  '\u1F552', // 185
  '\u1F553', // 186
  '\u1F554', // 187
  '\u1F555', // 188
  '\u1F556', // 189
  '\u1F557', // 190
  '\u1F558', // 191
  '\u1F559', // 192
  '\u1F55A', // 193
  '\u1F55B', // 194
  MISSING, // 195
  MISSING, // 196
  MISSING, // 197
  MISSING, // 198
  MISSING, // 199
  MISSING, // 200
  MISSING, // 201
  MISSING, // 202
  MISSING, // 203
  MISSING, // 204
  MISSING, // 205
  MISSING, // 206
  MISSING, // 207
  MISSING, // 208
  MISSING, // 209
  MISSING, // 210
  MISSING, // 211
  MISSING, // 212
  '\u232B', // 213
  '\u2326', // 214
  MISSING, // 215
  '\u27A2', // 216
  MISSING, // 217
  MISSING, // 218
  MISSING, // 219
  '\u27B2', // 220
  MISSING, // 221
  MISSING, // 222
  '\u2190', // 223: black left arrow
  '\u2192', // 224: black right arrow
  MISSING, // 225
  MISSING, // 226
  MISSING, // 227
  MISSING, // 228
  MISSING, // 229
  MISSING, // 230
  '\u2190', // 231: black left arrow
  '\u2192', // 232: black right arrow
  MISSING, // 233
  MISSING, // 234
  MISSING, // 235
  MISSING, // 236
  MISSING, // 237
  MISSING, // 238
  '\u21E6', // 239
  '\u21E8', // 240
  '\u21E7', // 241
  '\u21E9', // 242
  '\u2B04', // 243
  '\u21F3', // 244
  '\u2B00', // 245
  '\u2B01', // 246
  '\u2B03', // 247
  '\u2B02', // 248
  '\u25AD', // 249
  '\u25AB', // 250
  '\u2717', // 251
  '\u2713', // 252
  '\u2612', // 253
  '\u2611', // 254
  MISSING, // 255
];

// Maps ASCII values in Symbol font to unicode values
// Generated via scripts/notebook/map_symbol_to_unicode.py
const SYMBOL_TO_UNICODE = [
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  '\u0020',
  '\u0021',
  '\u2200',
  '\u0023',
  '\u2203',
  '\u0025',
  '\u0026',
  '\u220b',
  '\u0028',
  '\u0029',
  '\u2217',
  '\u002b',
  '\u002c',
  '\u2212',
  '\u002e',
  '\u002f',
  '\u0030',
  '\u0031',
  '\u0032',
  '\u0033',
  '\u0034',
  '\u0035',
  '\u0036',
  '\u0037',
  '\u0038',
  '\u0039',
  '\u003a',
  '\u003b',
  '\u003c',
  '\u003d',
  '\u003e',
  '\u003f',
  '\u2245',
  '\u0391',
  '\u0392',
  '\u03a7',
  '\u0394',
  '\u0395',
  '\u03a6',
  '\u0393',
  '\u0397',
  '\u0399',
  '\u03d1',
  '\u039a',
  '\u039b',
  '\u039c',
  '\u039d',
  '\u039f',
  '\u03a0',
  '\u0398',
  '\u03a1',
  '\u03a3',
  '\u03a4',
  '\u03a5',
  '\u03c2',
  '\u03a9',
  '\u039e',
  '\u03a8',
  '\u0396',
  '\u005b',
  '\u2234',
  '\u005d',
  '\u22a5',
  '\u005f',
  '\uf8e5',
  '\u03b1',
  '\u03b2',
  '\u03c7',
  '\u03b4',
  '\u03b5',
  '\u03c6',
  '\u03b3',
  '\u03b7',
  '\u03b9',
  '\u03d5',
  '\u03ba',
  '\u03bb',
  '\u03bc',
  '\u03bd',
  '\u03bf',
  '\u03c0',
  '\u03b8',
  '\u03c1',
  '\u03c3',
  '\u03c4',
  '\u03c5',
  '\u03d6',
  '\u03c9',
  '\u03be',
  '\u03c8',
  '\u03b6',
  '\u007b',
  '\u007c',
  '\u007d',
  '\u223c',
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  MISSING,
  '\u20ac',
  '\u03d2',
  '\u2032',
  '\u2264',
  '\u2044',
  '\u221e',
  '\u0192',
  '\u2663',
  '\u2666',
  '\u2665',
  '\u2660',
  '\u2194',
  '\u2190',
  '\u2191',
  '\u2192',
  '\u2193',
  '\u00b0',
  '\u00b1',
  '\u2033',
  '\u2265',
  '\u00d7',
  '\u221d',
  '\u2202',
  '\u2022',
  '\u00f7',
  '\u2260',
  '\u2261',
  '\u2248',
  '\u2026',
  '\uf8e6',
  '\uf8e7',
  '\u21b5',
  '\u2135',
  '\u2111',
  '\u211c',
  '\u2118',
  '\u2297',
  '\u2295',
  '\u2205',
  '\u2229',
  '\u222a',
  '\u2283',
  '\u2287',
  '\u2284',
  '\u2282',
  '\u2286',
  '\u2208',
  '\u2209',
  '\u2220',
  '\u2207',
  '\u00ae',
  '\u00a9',
  '\u2122',
  '\u220f',
  '\u221a',
  '\u22c5',
  '\u00ac',
  '\u2227',
  '\u2228',
  '\u21d4',
  '\u21d0',
  '\u21d1',
  '\u21d2',
  '\u21d3',
  '\u25ca',
  '\u2329',
  '\u00ae',
  '\u00a9',
  '\u2122',
  '\u2211',
  '\uf8eb',
  '\uf8ec',
  '\uf8ed',
  '\uf8ee',
  '\uf8ef',
  '\uf8f0',
  '\uf8f1',
  '\uf8f2',
  '\uf8f3',
  '\uf8f4',
  MISSING,
  '\u232a',
  '\u222b',
  '\u2320',
  '\uf8f5',
  '\u2321',
  '\uf8f6',
  '\uf8f7',
  '\uf8f8',
  '\uf8f9',
  '\uf8fa',
  '\uf8fb',
  '\uf8fc',
  '\uf8fd',
  '\uf8fe',
  MISSING,
];

export const INLINE = [
  'BIG',
  'SMALL',
  'TT',
  'EM',
  'BR',
  'KBD',
  'STRONG',
  'A',
  'IMG',
  'B',
  'I',
  'U',
  'DEL',
  'STRIKE',
  'SPAN',
  'SUB',
  'SUP',
  'BUTTON',
  'INPUT',
  'LABEL',
  'SELECT',
  'TEXTAREA',
  '#text',
  '#TEXT',
  'FONT',
  'CODE',
];
export const SKIP = ['STYLE', 'SCRIPT', 'NOSCRIPT', 'META'];

export const SYMBOL_FONT_FACE_TO_UNICODE_CHAR_MAP = {
  Symbol: SYMBOL_TO_UNICODE,
  Wingdings: WINGDINGS_TO_UNICODE,
};
